import { useEffect } from "react";
import api from "@/lib/api";
import { installOfflineQueueLifecycle } from "@/lib/offlineQueue";

/**
 * Fire-and-forget mount that wires the offline-BOL queue flush lifecycle
 * exactly once per app load. Renders nothing.
 */
export default function OfflineQueueBootstrap() {
  useEffect(() => {
    installOfflineQueueLifecycle(api);
  }, []);
  return null;
}
